
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/construction",
      function () {
        return require("private-next-pages/use-cases/construction.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-cases/construction"])
      });
    }
  